export type AgentName = "Copilot" | "Cowork" | "XAMI" | "Outreach" | "Pricing" | (string & {});

export interface AgentBadgeProps {
  agent: AgentName;
}

interface AgentLook {
  color: string;
  glyph: string;
}

const MAP: Record<string, AgentLook> = {
  Copilot: { color: "#2563eb", glyph: "M" },
  Cowork: { color: "#7c3aed", glyph: "C" },
  XAMI: { color: "#0c6b53", glyph: "X" },
  Outreach: { color: "#0891b2", glyph: "O" },
  Pricing: { color: "#b45309", glyph: "P" },
};

export function AgentBadge({ agent }: AgentBadgeProps) {
  const m: AgentLook =
    MAP[agent] ?? { color: "#64748b", glyph: agent ? agent.charAt(0) : "?" };
  return (
    <span
      className="pill"
      style={{
        background: "var(--bg-soft)",
        borderColor: "var(--border)",
        color: "var(--text-2)",
        fontSize: "10.5px",
        padding: "1px 7px 1px 4px",
        gap: "4px",
      }}
    >
      <span
        style={{
          width: 12,
          height: 12,
          borderRadius: 3,
          background: m.color,
          color: "white",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "8.5px",
          fontWeight: 700,
        }}
      >
        {m.glyph}
      </span>
      {agent}
    </span>
  );
}
